import React from 'react';
import { MapGeneralController } from 'src/feature-app/NewMap/MapGeneralController';
import { JourneyCitaPosventaDealerController } from './JourneyCitaPosventaDealerController';

/**
 * Este componente está creado únicamente para que JourneyCitaPosventaController tenga acceso a las variables de MapGeneralController.
 */
export const JourneyCitaPosventaDealerWrapper = () => {
	return (
		<MapGeneralController>
			<JourneyCitaPosventaDealerController />
		</MapGeneralController>
	);
};
